export default "__VITE_ASSET__CIAja26S__"